export function reOrderArray(
    list,
    startIndex,
    endIndex
) {

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export function getUniqueValuesInArray({ array, uniqueKey }) {
    let values = [];

    array.forEach(e => {
        if (values.includes(e[uniqueKey]) <= 0) {
            values.push(e[uniqueKey])
        }
    })

    return values;
}

export const formatUniqueValues = (array) => {
    return array.filter((currentValue, index, arr) => (
        arr.indexOf(currentValue) === index
    ))
}